export default __webpack_public_path__ + "static/media/ic-job-description-management icon.ad40f4a9.svg";